// extracted by mini-css-extract-plugin
export var aside = "Aside-module--aside--l9nvc";
export var asideNoRule = "Aside-module--asideNoRule--Z+ZyR";
export var cdsAssistiveText = "Aside-module--cds--assistive-text--qehlS";
export var cdsVisuallyHidden = "Aside-module--cds--visually-hidden--YxzhY";
export var hideFeedback = "Aside-module--hide-feedback--xqh9Z";
export var showFeedback = "Aside-module--show-feedback--mqh3s";
export var skeleton = "Aside-module--skeleton--GUUEn";